import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { IRequest } from "@/interfaces/IRequest";
import { OptionType } from "@/types/OptionType";
import { BusinessUnitDto } from "./business-unit.dto";
import { CreateBusinessUnitDto } from "./create-business-unit.dto";
import { UpdateBusinessUnitDto } from "./update-business-unit.dto";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class BusinessUnitsResource extends ResourceBaseService<
  BusinessUnitDto,
  CreateBusinessUnitDto,
  UpdateBusinessUnitDto
> {
  protected EntityDto = BusinessUnitDto;
  protected CreateEntityDto = CreateBusinessUnitDto;
  protected UpdateEntityDto = UpdateBusinessUnitDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/business-units");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";

    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((businessUnit) => businessUnit.mapEntityToOptionType([businessUnit.name]));
  }
}
